export default __webpack_public_path__ + "media/color/dcn-c16bdce9.svg";